import React, { useState, useEffect } from 'react';
import api from '../api';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get('orders/my', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(res.data);
      } catch (err) {
        console.error('Error fetching orders:', err);
        setMessage('Error fetching orders');
      }
    };
    fetchOrders();
  }, []);

  if (!orders.length && !message) {
    return <div className="container mt-5">Loading orders...</div>;
  }

  return (
    <div className="container mt-5">
      <h2 className="text-success mb-4">My Orders</h2>
      
      {/* Se c'è un messaggio di errore */}
      {message && (
        <div className="alert alert-danger text-center">
          {message}
        </div>
      )}
      
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <div className="accordion" id="ordersAccordion">
          {orders.map((order, index) => {
            const orderId = order._id;
            const collapseId = `collapse-${orderId}`;
            const headingId = `heading-${orderId}`;

            return (
              <div className="accordion-item border-0 mb-3 shadow-sm" key={orderId}>
                <h2 className="accordion-header" id={headingId}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${collapseId}`}
                    aria-expanded="false"
                    aria-controls={collapseId}
                  >
                    <div className="d-flex flex-column w-100 text-start">
                      <div><strong>Order ID:</strong> {orderId}</div>
                      <div><strong>Date:</strong> {new Date(order.createdAt).toLocaleString()}</div>
                      <div><strong>Status:</strong> {order.status}</div>
                      <div><strong>Total:</strong> €{order.totalAmount?.toFixed(2)}</div>
                    </div>
                  </button>
                </h2>
                <div
                  id={collapseId}
                  className="accordion-collapse collapse"
                  aria-labelledby={headingId}
                  data-bs-parent="#ordersAccordion"
                >
                  <div className="accordion-body">
                    {/* Se hai un campo "items" o "orderItems" */}
                    {order.orderItems?.length > 0 && (
                      <div>
                        <h5 className="text-success">Products</h5>
                        <ul className="list-group mb-3">
                          {order.orderItems.map((item, idx) => (
                            <li className="list-group-item d-flex align-items-center" key={idx}>
                              {/* Se hai un reference al product e un campo images? */}
                              {item.product?.images?.[0] ? (
                                <img
                                  src={`https://api.iovendosiciliano.it/${item.product.images[0]}`}
                                  alt={item.product.name}
                                  style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                                  className="me-3"
                                />
                              ) : (
                                <img
                                  src="https://via.placeholder.com/50"
                                  alt="placeholder"
                                  className="me-3"
                                />
                              )}
                              <div className="flex-grow-1">
                                <strong>{item.product?.name}</strong>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                  Qty: {item.quantity}
                                </div>
                              </div>
                              <strong>
                                €{(item.price * item.quantity).toFixed(2)}
                              </strong>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Indirizzo di spedizione, se presente */}
                    {order.shippingAddress && (
                      <div className="mb-3">
                        <h5 className="text-success">Shipping Address</h5>
                        <p className="mb-0" style={{ fontSize: '0.95rem' }}>
                          {order.shippingAddress.fullName}<br />
                          {order.shippingAddress.street}, {order.shippingAddress.city}, {order.shippingAddress.province} {order.shippingAddress.zip}<br />
                          {order.shippingAddress.country}
                        </p>
                      </div>
                    )}
                    
                    {/* Shipping cost e altre info */}
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Shipping Cost:</span>
                      <strong>€{(parseFloat(process.env.REACT_APP_SHIPPING_COST) || 0).toFixed(2)}</strong>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Order Status:</span>
                      <strong>{order.status}</strong>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyOrders;
